// extracted by mini-css-extract-plugin
export default {"error":"date-range_error__TeCLR"};